import { toast as toast_} from 'sonner';

export function useToast() {
  function toast(opts?: any) {
    if(opts.variant === 'destructive') {
      toast_.error(opts.description);
    }
    else {
      toast_.success(opts.description);
    }
  }
  return {toast}
}






// import { useEffect, useState } from "react"

// // import type { ToastProps } from "@/components/ui/toast"

// const TOAST_LIMIT = 5
// const TOAST_REMOVE_DELAY = 1000

// type ToasterToast = ToastProps & {
//   id: string
//   title?: React.ReactNode
//   description?: React.ReactNode
//   // action?: ToastActionElement
// }

// const actionTypes = {
//   ADD_TOAST: "ADD_TOAST",
//   UPDATE_TOAST: "UPDATE_TOAST",
//   DISMISS_TOAST: "DISMISS_TOAST",
//   REMOVE_TOAST: "REMOVE_TOAST",
// } as const

// let count = 0

// function generateId() {
//   count = (count + 1) % Number.MAX_VALUE
//   return count.toString()
// }

// type ActionType = typeof actionTypes

// type Action =
//   | {
//       type: ActionType["ADD_TOAST"]
//       toast: ToasterToast
//     }
//   | {
//       type: ActionType["UPDATE_TOAST"]
//       toast: Partial<ToasterToast>
//     }
//   | {
//       type: ActionType["DISMISS_TOAST"]
//       toastId?: string
//     }
//   | {
//       type: ActionType["REMOVE_TOAST"]
//       toastId?: string
//     }

// interface State {
//   toasts: ToasterToast[]
// }

// export const reducer = (state: State, action: Action): State => {
//   switch (action.type) {
//     case "ADD_TOAST":
//       return {
//         ...state,
//         toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT),
//       }

//     case "UPDATE_TOAST":
//       return {
//         ...state,
//         toasts: state.toasts.map((t) =>
//           t.id === action.toast.id ? { ...t, ...action.toast } : t
//         ),
//       }

//     case "DISMISS_TOAST": {
//       const { toastId } = action

//       // If no id is supplied, dismiss all
//       if (toastId === undefined) {
//         return {
//           ...state,
//           toasts: state.toasts.map((t) => ({
//             ...t,
//             open: false,
//           })),
//         }
//       }

//       // Find the toast
//       return {
//         ...state,
//         toasts: state.toasts.map((t) =>
//           t.id === toastId
//             ? {
//                 ...t,
//                 open: false,
//               }
//             : t
//         ),
//       }
//     }

//     case "REMOVE_TOAST": {
//       const { toastId } = action

//       if (toastId === undefined) {
//         return {
//           ...state,
//           toasts: [],
//         }
//       }

//       return {
//         ...state,
//         toasts: state.toasts.filter((t) => t.id !== toastId),
//       }
//     }
//     default:
//       return state
//   }
// }

// export function useToast() {
//   const [state, setState] = useState<State>({ toasts: [] })

//   useEffect(() => {
//     state.toasts.forEach((toast) => {
//       if (toast.open === false) {
//         setTimeout(() => {
//           setState((state) => ({
//             ...state,
//             toasts: state.toasts.filter((t) => t.id !== toast.id),
//           }))
//         }, TOAST_REMOVE_DELAY)
//       }
//     })
//   }, [state.toasts])

//   function toast({
//     ...props
//   }: Omit<ToasterToast, "id" | "open">) {
//     const id = generateId()

//     setState((state) => ({
//       ...state,
//       toasts: [
//         {
//           ...props,
//           id,
//           open: true,
//         },
//         ...state.toasts,
//       ].slice(0, TOAST_LIMIT),
//     }))

//     return {
//       id,
//       dismiss: () => dismiss(id),
//       update: (props: ToasterToast) => update({ ...props, id }),
//     }
//   }

//   function update(toast: ToasterToast) {
//     setState((state) => ({
//       ...state,
//       toasts: state.toasts.map((t) => (t.id === toast.id ? { ...t, ...toast } : t)),
//     }))
//   }

//   function dismiss(toastId?: string) {
//     setState((state) => ({
//       ...state,
//       toasts: state.toasts.map((t) =>
//         toastId === undefined || t.id === toastId
//           ? {
//               ...t,
//               open: false,
//             }
//           : t
//       ),
//     }))
//   }

//   return {
//     ...state,
//     toast,
//     dismiss,
//     update,
//   }
// }
